import pluck from 'transmute/pluck';
export const getPropertiesFromView = ({
  columns
}) => pluck('name', columns);